module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_05.1cb97a2c.svg";